import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const DigestsPage = lazy(() => import('./index'))

function DigestsPageLazy(props) {
    return (
        <Suspense fallback={<Loader/>}>
            <DigestsPage {...props} />
        </Suspense>
    );
}

export default DigestsPageLazy;
export { DigestsPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/laws-digests-item-page/lazy.js